module.exports = __webpack_public_path__ + "img/flowback2.cea08027.png";